import { render, staticRenderFns } from "./AppDetailPage.vue?vue&type=template&id=6c082fc3&"
import script from "./AppDetailPage.vue?vue&type=script&lang=ts&"
export * from "./AppDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports